<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="自定义扩展详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="编码" class="detail-form-item" prop="code">
                  <el-input size="medium" v-model="entity.code"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="名称" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.name"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="类型" class="detail-form-item" prop="type">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                    <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="状态" class="detail-form-item">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                    <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="自定义字段">
                <div>
                  <el-button size="mini" type="danger" @click="addRow">增行</el-button>
                </div>
                <el-alert v-if="error" title="表格验证提示：" type="error" :description="error" show-icon>
                </el-alert>
                <el-table :data="entity.customDetails" border style="width: 100%" @row-click="rowClick">
                  <el-table-column prop="no" label="序号" width="50"> </el-table-column>
                  <el-table-column prop="name" label="字段名称" width="160">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input size="mini" v-model="scope.row.name">
                        </el-input>
                      </span>
                      <span v-else>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="label" label="显示名称">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input size="mini" v-model="scope.row.label">
                        </el-input>
                      </span>
                      <span v-else>{{scope.row.label}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="字段类型" width="160">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-select size="mini" v-model="scope.row.type" @change="fieldTypeChange(scope.row)">
                          <el-option v-for="item in fieldTypes" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                          </el-option>
                        </el-select>
                      </span>
                      <span v-else>{{scope.row.typeName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sortNo" label="排序字段" width="160">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input-number size="mini" v-model="scope.row.sortNo"></el-input-number>
                      </span>
                      <span v-else>{{scope.row.sortNo}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="required" label="是否必录" width="100">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-checkbox v-model="scope.row.required"></el-checkbox>
                      </span>
                      <span v-else>{{scope.row.required?'是':'否'}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="readOnly" label="是否只读" width="100">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-checkbox v-model="scope.row.readOnly"></el-checkbox>
                      </span>
                      <span v-else>{{scope.row.readOnly?'是':'否'}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="rows" label="行数" width="160">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input-number size="mini" v-model="scope.row.rows"></el-input-number>
                      </span>
                      <span v-else>{{scope.row.rows}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="itemsCode" label="字典编码" width="120">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input size="mini" v-model="scope.row.itemsCode">
                        </el-input>
                      </span>
                      <span v-else>{{scope.row.itemsCode}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="defaultValue" label="默认值" width="100">
                    <template #default="scope">
                      <span v-if="scope.row.edit">
                        <el-input size="mini" v-model="scope.row.defaultValue">
                        </el-input>
                      </span>
                      <span v-else>{{scope.row.defaultValue}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template #default="scope">
                      <el-button size="mini" type="danger" @click="deleteRow(scope)">删行</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Custom, Dict } from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CustomService } from "@/script/apps/system/service/CustomService";
import { DictService } from "@/script/apps/system/service/DictService";
import { DictUtil } from "@/script/core/Dict";
import { ElMessage } from "element-plus";

@Options({})
export default class CustomDetail extends BaseDetail {
  private service = new CustomService();

  private customDeleteDetails: CustomDetail[] = [];

  protected fieldTypes: Dict[] = [];

  private error: string | null = null;

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
  };

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "sys_custom",
      "/sys/custom",
      "/sys/custom",
      this.service
    );
    data.typesName = "sys-custom-type";
    return data;
  }

  public newEntity() {
    const entity: Custom = { customDetails: [], customDeleteDetails: [] };
    this.injectDetailData(entity.customDetails!, entity.customDeleteDetails!);
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const dictService = new DictService();
    dictService.loadChildItems("sys-custom-field-type", (data: any) => {
      this.fieldTypes = data;
    });
  }

  public afterLoad(data: any) {
    const custom = this.entity as Custom;
    custom.customDeleteDetails = [];
    this.injectDetailData(custom.customDetails!, custom.customDeleteDetails!);
    this.generateRowNo();
    if (custom.customDetails) {
      custom.customDetails.forEach((item) => {
        item.typeName = DictUtil.getItemName(this.fieldTypes, item.type);
      });
    }
  }

  public beforeSave() {
    const custom = this.entity as Custom;
    if (custom.customDetails) {
      const errors: string[] = [];
      custom.customDetails.forEach((item) => {
        if (this.isEmpty(item.name)) {
          errors.push(`第 [${item.no}] 行的 [字段名称] 不能为空！`);
        }
        if (this.isEmpty(item.label)) {
          errors.push(`第 [${item.no}] 行的 [显示名称] 不能为空！`);
        }
        if (this.isEmpty(item.type)) {
          errors.push(`第 [${item.no}] 行的 [字段类型] 不能为空！`);
        }
      });
      console.info(errors);
      if (errors.length > 0) {
        this.error = errors.join("");
        ElMessage.error(`验证表格内容失败!具体原因请查看表格上方提示。`);
        return false;
      } else {
        this.error = null;
      }
    }

    return true;
  }

  private isEmpty(value: string | null | undefined): boolean {
    if (value === undefined) {
      return true;
    }
    if (value === null) {
      return true;
    }
    value = value.trim();
    if (value.length === 0) {
      return true;
    }
    return false;
  }

  private fieldTypeChange(row: any) {
    row.typeName = DictUtil.getItemName(this.fieldTypes, row.type);
  }
}
</script>

<style lang="scss">
</style>
